module.exports = __webpack_public_path__ + "static/media/homen-arena.86552ea7.png";